import React from "react";
import { Table,Empty } from "antd";
import "./TableComponent.css"
const TableComponent = ({columns,dataSource})=>{
     
   if(!dataSource || dataSource.length==0){
    return <Empty/>
   }
    return <div id="TableComponent">
        
        <Table dataSource={dataSource} columns={columns} style={{textAlign:"center"}} />
        
    </div>;
}

export default TableComponent;